export default __webpack_public_path__ + "static/media/increment.17ddc6b9.svg";